<header class="header" id="header">
  <nav class="navbar navbar-expand-lg p-0">
    <div class="container-fluid">
      <a class="navbar-brand" href="/" (click)="navigateToHome($event)">
        <img src="assets/Levelab_logo.png" alt="Logo" height="50">
      </a>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <menu class="navbar-nav mb-2 mb-lg-0 w-100 d-flex justify-content-between">
          <div class="nav-group d-flex">
            <li class="nav-item" *ngIf="currentUserGroup === 'STUDENT'">
              <a class="nav-link" aria-current="page" [routerLink]="['/dashboard/lessons']">
                <i class='bx bx-grid-alt nav_icon'></i>&nbsp;Lecciones</a>
            </li>
          </div>
          <hr>
          <div class="nav-group d-flex">
            <!-- <li class="nav-item">
              <a class="nav-link" aria-current="page" href="/#">
                <i class='bx bx-message-square-detail nav_icon'></i></a>
            </li> -->
            <li *ngIf="profiles.length>1" class="nav-item">
              <div class="profile-selector">
                <select
                  [(ngModel)]="selectedOrganizationId"
                  (change)="onOrganizationChange()"
                  class="profile-dropdown"
                >
                  <option *ngFor="let profile of profiles" [value]="profile.id">
                    {{ profile.name }}
                  </option>
                </select>
              </div>
              <!-- TODO -->
              <!-- <a class="nav-link" aria-current="page" href="/#">
                <i class='bx bx-bell nav_icon'></i></a> -->
            </li>
            <li class="nav-item dropdown dropdown-hover">
              <a class="nav-link dropdown-menu-toggle" href="#" id="headerProfileDropdown"
                data-bs-toggle="dropdown" aria-expanded="false">
                <div d-flex>
                  <img [src]="getProfileImg()" 
                        alt="Profile picture" class="profile-picture">
                  <span class="ms-2"><strong><small>{{ getFullName() }}</small></strong></span>
                </div>
              </a>
              <menu class="dropdown-menu dropdown-menu-right" aria-labelledby="headerProfileDropdown">
                <li><a class="dropdown-item" [routerLink]="['/profile']">
                    <i class='bx bx-user nav_icon'></i>&nbsp;Perfil
                  </a></li>
                <li><a class="dropdown-item" (click)="openBugReportDialog()">
                    <i class="fa-solid fa-bullhorn"></i>&nbsp;Informar
                  </a></li>
                <li *ngIf="currentUserGroup === 'STUDENT'"><a class="dropdown-item" [routerLink]="['/files']">
                    <i class='bx bx-folder nav_icon'></i>&nbsp;Ficheros
                  </a></li>
                <li>
                  <hr class="dropdown-divider">
                </li>
                <li><a class="dropdown-item" (click)="logout()">
                    <i class='bx bx-log-out nav_icon'></i>&nbsp;Salir
                  </a></li>
              </menu>
            </li>
          </div>

        </menu>
      </div>
    </div>
  </nav>
</header>
<!-- <button class="btn-back" (click)="navigateToPreviousPage()">
  <i class="fas fa-arrow-left"></i>&nbsp;Volver
</button> -->

<ng-template #pendingChangesDialogTemplate>
    <shared-generic-dialog
    [primaryButtonText]="'Sí, salir sin guardar'"
    [secondaryButtonText]="'Cancelar'">
      Tienes cambios pendientes, ¿seguro que quieres cerrar sesión?
    </shared-generic-dialog>
  </ng-template>